export function isElement(node) {
  return Boolean(node) && node.nodeType === 1;
}

function focusKey(element) {
  if (element.id) {
    return '#' + CSS.escape(element.id);
  }

  if (element.name) {
    return '[name="' + element.name.replace(/"/g, '\\"') + '"]';
  }

  return null;
}

export function snapshotFocus(root) {
  const element = document.activeElement;

  if (!isElement(element) || element === document.body) {
    return null;
  }

  if (root && root !== document && !root.contains(element)) {
    return null;
  }

  const key = focusKey(element);
  if (!key) {
    return null;
  }

  const snapshot = { key };

  if (typeof element.selectionStart === 'number') {
    snapshot.selectionStart = element.selectionStart;
    snapshot.selectionEnd = element.selectionEnd;
  }

  return snapshot;
}

export function restoreFocus(snapshot, root) {
  if (!snapshot) {
    return;
  }

  const scope = root && root !== document ? root : document;
  const element = scope.querySelector(snapshot.key);

  if (!element || document.activeElement === element) {
    return;
  }

  try {
    element.focus({ preventScroll: true });
  } catch (error) {
    return;
  }

  if (typeof snapshot.selectionStart === 'number' && typeof element.setSelectionRange === 'function') {
    try {
      element.setSelectionRange(snapshot.selectionStart, snapshot.selectionEnd);
    } catch (error) {
      return;
    }
  }
}
